import { render, staticRenderFns } from "./GreenLocationForm.vue?vue&type=template&id=99703b66&scoped=true&"
import script from "./GreenLocationForm.vue?vue&type=script&lang=js&"
export * from "./GreenLocationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99703b66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99703b66')) {
      api.createRecord('99703b66', component.options)
    } else {
      api.reload('99703b66', component.options)
    }
    module.hot.accept("./GreenLocationForm.vue?vue&type=template&id=99703b66&scoped=true&", function () {
      api.rerender('99703b66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/GreenLocationForm.vue"
export default component.exports